/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TextWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABkUlEQVR4nNVUvUoDQRA+0QfQ0p9eX0ALUVJEFLnbmVnxMhNTWIsQzVtYiW0UfAOttBMEkxi0Ep9BKwlYp4nseZHL5ZLsJQZ0YODuvtv5vhm+Hcf5D5HJZKYU8TWgXPm+P5m6AKDUFUmtJ67lEEhaJhXxQariWhdmg4MojSTcdfdmgPhDkVyaNM+I+9P26iG3EahDriThCuXM4K7rzwPIXNjFqT0B8VHYfjmOeTv5JYXcNLinc8tE+ZXvbrkJ4C9aESjk83BEx10Y8e3P7JGfAOU58n5j1wFKNVBIvNmhnni7XcwkIq96lF/r/JbbiimSWvSHeCri94j61yhmiiPyescZlJeYWq70IwCSt4iY+wH/mrzrOx4PORsqqTrjCNBS7OWg3yEgKQcEWooJ2EmAgewOT4Chg5CzabDEGOQgsM0eN97GQS2bVCQPaXfQYxwzl25kd7V3kCK+6CaX0sjuau8gACn1xBLcZR1mNEk7aCgHJYVC+TRFtC4sJGCNEJsdgSBYv3XHcSa6MGPpca2PPxdfvGVLGl06DVQAAAAASUVORK5CYII=)
 */
export const TextWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 1.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.92 1.92 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11.45 8c.35 0 .6.35.55.7-.02.2-.02.4 0 .6.04.35-.2.7-.55.7h-1.6l-.67 4h4.97l.26-1.55c.05-.27.31-.45.59-.45h.92c.31 0 .55.28.5.58L16.18 14H20a1 1 0 1 1 0 2h-4.15l-.86 5.16a1 1 0 0 1-1.98-.32l.8-4.84H8.86l-.86 5.16A1 1 0 0 1 6 20.84L6.82 16H3a1 1 0 1 1 0-2h4.15l.67-4H4a1 1 0 0 1 0-2h4.15l.86-5.16a1 1 0 1 1 1.98.32L10.19 8h1.26Z"
        className={colorClass}
      />
    </svg>
  );
};
